import type { Filter } from '@repo/api-codegen';
import { type ApiCatalogSort } from '../../api';
import { useCatalogInfiniteList } from '../../api/hooks/resourceCatalog';

export function archivedEntitiesInfiniteList(props: {
	page?: number | undefined;
	filters?: { filter: Filter; search_term?: string; sort?: ApiCatalogSort };
}) {
	const { page, filters } = props;

	const filter: Filter = filters?.filter ?? {
		operator: 'and',
		operands: [
			{
				operator: 'exact',
				operands: [],
				field: 'archived',
				value: true,
			},
			{
				operator: 'exact',
				operands: [],
				field: 'stale',
				value: false,
			},
		],
	};

	return useCatalogInfiniteList({
		filters: {
			page,
			filter: filter,
			sort: filters?.sort,
			search_term: filters?.search_term,
			grab_all_entity_types: true,
		},
	});
}
